import { Flex } from "@chakra-ui/layout";
import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Testimonial from "../../components/Testimonial";

type TestimonialsProps = {};
const Testimonials: React.FC<TestimonialsProps> = () => {
  return (
    <Flex
      w="100%"
      h="50vh"
      bg="#52b69a"
      align="center"
      justify="space-between"
    >
      <FaAngleLeft color="#ffffff" size="4rem" />
      <Testimonial />
      <FaAngleRight color="#ffffff" size="4rem" />
    </Flex>
  );
};

export default Testimonials;
